<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading full-character-formatting" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content"><i>For Lynne Welch and Sue Krekeler, my fabulous beta readers. Mega-thanks to my niece, Sara Krafft, who found pictures of the “old” Pasadena Public Library for me. Many thanks, too, to Sten Voght Cantwell, who gave me the idea for this book. Thank you buckets and buckets. I need all the help I can get!Oh, and before I forget to mention it and somebody screams, I know perfectly well that Caltech’s Athenaeum didn’t open until 1930, but it’s such a lovely, charming place, I decided to give Daisy an interesting location to conduct some of her sleuthing.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?42de462e